import React from "react";
import { lang } from "../../../middleware/lang";
import { formatNumber } from "../../../middleware/common-functions";

const SplitBillPanel = ({
  order,
  selectedTotal,
  billSplits,
  addBillSplit,
  removeBillSplit,
  finalizeBillSplit,
  exitSplitBillMode,
  splitPaying,
  billPaymentType,
  setBillPaymentType,
  billCardType,
  setBillCardType,
  settings,
  printSplitBillTicket,
}) => {
  const totalAssigned = billSplits.reduce((sum, s) => sum + s.amount, 0);
  const remaining = order.total - totalAssigned;
  const allAssigned = remaining <= 0.01;

  const handlePaymentType = (ev) => {
    const type = ev.currentTarget.dataset.type;
    const card = ev.currentTarget.dataset.card;
    setBillPaymentType(type);
    setBillCardType(card || undefined);
  };

  const paymentLabel = (type, card) => {
    if (type === "terminal" && card === "debit") return "TD";
    if (type === "terminal" && card === "credit") return "TC";
    if (type === "terminal") return "Terminal";
    if (type === "cash") return lang("Efectivo", "Cash");
    return type;
  };

  return (
    <div className="col-md-4 mt-4 mt-md-0">
      <div className="p-3">
        <h5 className="mb-3">
          <i className="fas fa-receipt mr-2"></i>
          {lang("Dividir Cuenta", "Split Bill")}
        </h5>

        <div className="text-center mb-3">
          <h2 className="my-0 display-4">
            <b className="text-dark invert">${formatNumber(order.total)}</b>
          </h2>
          <small className="text-muted">Total</small>
        </div>

        {billSplits.length > 0 && (
          <div className="mb-3">
            <h6 className="mb-1">
              <b>{lang("Cuentas divididas", "Split bills")}</b>
            </h6>
            {billSplits.map((split, i) => (
              <div
                key={i}
                className="d-flex justify-content-between align-items-center py-1 border-bottom"
              >
                <span>
                  {lang("Cuenta", "Bill")} {i + 1}
                  <span className="badge badge-secondary ml-2">
                    {paymentLabel(split.payment_type, split.card_type)}
                  </span>
                </span>
                <span className="d-flex align-items-center">
                  <b className="mr-2">${formatNumber(split.amount)}</b>
                  <button
                    className="btn btn-sm btn-link text-danger p-0"
                    onClick={() => removeBillSplit(i)}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </span>
              </div>
            ))}
            <div className="d-flex justify-content-between mt-1">
              <span className="text-muted">
                {lang("Restante", "Remaining")}
              </span>
              <b className={remaining > 0.01 ? "text-danger" : "text-success"}>
                ${formatNumber(Math.max(remaining, 0))}
              </b>
            </div>
          </div>
        )}

        {!allAssigned && (
          <>
            <hr />
            <div className="mb-2">
              <small className="text-muted">
                {lang("Forma de pago para esta cuenta", "Payment type for this split")}
              </small>
            </div>
            <div className="row mb-3">
              {settings.cards_type ? (
                <>
                  <div className="col-4 px-1">
                    <button
                      className={`btn btn-block btn-sm py-2 ${
                        billPaymentType === "terminal" && billCardType === "debit"
                          ? "btn-dark"
                          : "btn-outline-secondary"
                      }`}
                      data-type="terminal"
                      data-card="debit"
                      onClick={handlePaymentType}
                    >
                      TD
                    </button>
                  </div>
                  <div className="col-4 px-1">
                    <button
                      className={`btn btn-block btn-sm py-2 ${
                        billPaymentType === "terminal" && billCardType === "credit"
                          ? "btn-dark"
                          : "btn-outline-secondary"
                      }`}
                      data-type="terminal"
                      data-card="credit"
                      onClick={handlePaymentType}
                    >
                      TC
                    </button>
                  </div>
                </>
              ) : (
                <div className="col-6 px-1">
                  <button
                    className={`btn btn-block btn-sm py-2 ${
                      billPaymentType === "terminal"
                        ? "btn-dark"
                        : "btn-outline-secondary"
                    }`}
                    data-type="terminal"
                    onClick={handlePaymentType}
                  >
                    Terminal
                  </button>
                </div>
              )}
              <div className={`${settings.cards_type ? "col-4" : "col-6"} px-1`}>
                <button
                  className={`btn btn-block btn-sm py-2 ${
                    billPaymentType === "cash"
                      ? "btn-dark"
                      : "btn-outline-secondary"
                  }`}
                  data-type="cash"
                  onClick={handlePaymentType}
                >
                  {lang("Efectivo", "Cash")}
                </button>
              </div>
            </div>

            <div className="mb-2">
              <small className="text-muted">
                {lang("Productos seleccionados", "Selected products")}
              </small>
              <h4 className="mb-0">
                ${formatNumber(selectedTotal)}
              </h4>
            </div>

            <button
              className="btn btn-block btn-outline-primary py-3 my-2"
              onClick={addBillSplit}
              disabled={selectedTotal <= 0}
            >
              <i className="fas fa-plus mr-2"></i>
              {lang("Agregar Cuenta", "Add Split")}
            </button>
          </>
        )}

        {allAssigned && (
          <>
            <button
              className="btn btn-block btn-success py-3 my-2"
              onClick={finalizeBillSplit}
              disabled={splitPaying}
            >
              {splitPaying ? (
                <i className="fas fa-spinner fa-spin mr-2"></i>
              ) : (
                <i className="fas fa-check mr-2"></i>
              )}
              {lang("Completar Cobro", "Complete Payment")}
            </button>
            <button
              className="btn btn-block btn-outline-secondary py-2 my-1"
              onClick={printSplitBillTicket}
              disabled={splitPaying}
            >
              <i className="fas fa-print mr-2"></i>
              {lang("Imprimir Cuentas", "Print Bills")}
            </button>
          </>
        )}

        {billSplits.length > 0 && !allAssigned && (
          <button
            className="btn btn-block btn-outline-secondary py-2 my-1"
            onClick={printSplitBillTicket}
            disabled={splitPaying}
          >
            <i className="fas fa-print mr-2"></i>
            {lang("Imprimir Cuentas", "Print Bills")}
          </button>
        )}

        <button
          className="btn btn-block btn-link text-muted mt-3"
          onClick={exitSplitBillMode}
          disabled={splitPaying}
        >
          {lang("Cancelar", "Cancel")}
        </button>
      </div>
    </div>
  );
};

export default SplitBillPanel;
